import { INDUSTRY_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: INDUSTRY_MNG,
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入行业名',
    moreBtnWidth: 160,
    searchFieldNameArr: ['industryName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'IndustryCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '行业名',
          prop: 'industryName',
          sortField: 'industryName'
        }
      },
      {
        props: {
          label: '行业编码',
          prop: 'industryCode',
          sortField: 'industryCode'
        }
      },
      {
        props: {
          label: '备注',
          prop: 'remarks'
        }
      },
      {
        props: {
          label: '行业场景说明',
          prop: 'sceneDesc'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '3'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        label: '场景管理',
        command: 'SceneManager',
        icon: 'el-icon-edit-outline'
      },
      {
        label: '场景目录管理',
        command: 'SceneDirManager',
        icon: 'el-icon-message'
      },
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'IndustryEdit',
        name: 'edit'
      }
      // },
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'IndustryDelete',
      //   name: 'delete',
      //   confirm: {
      //     msg: 'tips.confirm.industryMng.deleteMsg'
      //   }
      // }
    ]
  }
}
